import ScrollObserver from './ScrollObserver'
import ResizeObserver from './ResizeObserver'
import Log from '../../Log'

export default class ChangeObservers {
  constructor (node, onChange) {
    this._onChange = onChange
    const observers = this._observers = []

    observers.push(new ScrollObserver(node, onChange))
    observers.push(new ResizeObserver(node, onChange))
    Log.debug('Created change observers')
  }

  _onEvent () {
    /** TODO event throttle */
    this._onChange()
  }

  stop () {
    this._observers.forEach(observer => observer.stop())
  }
}
